import { render } from "./chaxund.vue?vue&type=template&id=139ddee1&scoped=true"
import script from "./chaxund.vue?vue&type=script&lang=js"
export * from "./chaxund.vue?vue&type=script&lang=js"

import "./chaxund.vue?vue&type=style&index=0&id=139ddee1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-139ddee1"

export default script